import * as React from 'react';
import { Helmet } from 'react-helmet';

export interface TwitterShareProps {
  title: string
  description: string
  account: string | null
  image: string | null
  pageUrl: string
}

export const TwitterShare: React.FunctionComponent<TwitterShareProps> = ({ title, description, account, image, pageUrl }) => (
  <Helmet>
    <meta property="twitter:title" content={title} />
    <meta property="twitter:description" content={description} />
    {account ? <meta property="twitter:site" content={account} /> : null}
    {image ? <meta property="twitter:image" content={image} /> : null}
    <meta property="twitter:url" content={pageUrl} />
    <meta property="twitter:card" content="summary_large_image" />
  </Helmet>
);
